export default __webpack_public_path__ + "static/media/pencil-edit.674749a2.svg";